import { Children, isValidElement } from 'react'

/**
 * Returns an array of valid React elements from `children`, excluding null, undefined,
 * booleans, numbers, and strings. Uses `Children.toArray` so fragments are flattened
 * and keys are preserved. Useful when iterating or checking child types in compound components.
 *
 * @param children - React node (e.g. `props.children`).
 * @returns Array of `React.ReactElement` only; non-element nodes are omitted.
 *
 * @example
 * ```tsx
 * const elements = getValidChildren(children)
 * const first = elements[0]
 * if (first?.type === Slot) { ... }
 * ```
 */
export function getValidChildren(children: React.ReactNode) {
  return Children.toArray(children).filter((child) => isValidElement(child)) as React.ReactElement[]
}
